import { ASSET_TYPE } from '@24i/nxg-sdk-photon';
import { SOTT_DEFAULT_WEB_SCREENS } from '../../navigation/constants';

export const isValidAssetParams = (params: string[]) => {
    if (params?.length !== 2) return false;
    if (!Object.values(ASSET_TYPE).includes(params[0] as ASSET_TYPE)) return false;
    return !!params[1];
};

export const getDeepLinkWebRoute = (path: string) => {
    if (path) {
        const parts = path.split('__');
        const page = parts[0];
        const params = parts.slice(1);

        if (!isValidAssetParams(params)) return null;
        const [assetType, assetId] = params as [ASSET_TYPE, string];

        switch (page) {
            case 'details':
                return SOTT_DEFAULT_WEB_SCREENS.Details.getLink({
                    type: assetType,
                    id: assetId,
                });
            case 'player':
                return SOTT_DEFAULT_WEB_SCREENS.Playback.getLink({
                    type: assetType,
                    id: assetId,
                });
            default:
        }
    }

    return null;
};
